import { Box, CircularProgress, useMediaQuery } from "@mui/material";
import React, { useState } from "react";
import LastPlacesScroller from "../components/widgets/LastPlacesScroller/LastPlacesScroller";
import MapSection from "../components/widgets/MapSection/MapSection";
import PlacesCounter from "../components/widgets/PlacesCounter/PlacesCounter";
import { useLastPlaces } from "../hooks/useLastPlaces";
import { usePlacesData } from "../hooks/usePlacesData";
import { useTranslatedTitle } from "../utils/utils";
import { useTranslation } from "react-i18next";
import QuoteWithArrow from "../components/widgets/QuoteWithArrow/QuoteWithArrow";

interface LastPlacesWrapperProps {
  t: (key: string) => string;
}

const LastPlacesWrapper: React.FC<LastPlacesWrapperProps> = React.memo(
  ({ t }) => {
    const avatars = useLastPlaces(t);

    if (avatars.length === 0) {
      return (
        <Box display="flex" justifyContent="center" p={2}>
          <CircularProgress />
        </Box>
      );
    }

    return <LastPlacesScroller avatars={avatars} />;
  }
);
const Home = () => {
  useTranslatedTitle("title.welcome");
  const { t } = useTranslation();

  const { places, loading } = usePlacesData(t);

  const [showCounter, setShowCounter] = useState(true);
  const isSmallScreen = useMediaQuery("(max-width:600px)");

  if (loading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="100vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <>
      <Box
        display="flex"
        flexDirection="column"
        height="85vh"
        position="relative"
        minHeight={600}
      >
        {showCounter && !isSmallScreen && places.length > 1 && (
          <PlacesCounter count={places.length} />
        )}
        <MapSection
          places={places}
          onMapInteraction={() => setShowCounter(false)}
        />
        <LastPlacesWrapper t={t} />
      </Box>
      <QuoteWithArrow />
    </>
  );
};

export default Home;
